module.exports = __webpack_public_path__ + "static/media/nuestra-app.2482b266.jpg";